export enum Theme {
    Blue = 'blue',
    Dark = 'dark',
    Default = 'default',
    Green = 'green',
    LightPink = 'light-pink',
    Pink = 'pink',
    Purple = 'purple'
}
